import { FC } from 'react'
import { Input, InputNumber, Space, Typography } from 'antd'
import { Filters } from '../../types'
/*
import useRequest, { RequestTypes } from '../../../hooks/useRequest'
import { DropdownSelector2 } from '../../../ui'
 */

const { Text } = Typography

const Filter: FC<{ onChange: (filters: Filters) => void; filters: Filters }> = ({
    onChange,
    filters,
}) => {
    const handleChange = (key: keyof Filters, value: string | number) => {
        const updated = { ...filters, [key]: value }
        onChange(updated)
    }

    return (
        <Space style={{ marginBottom: 16 }} direction="horizontal">
            <div style={{ width: 380 }}>
                <Text>Владелец атрибутов генерации</Text>
                <Input
                    placeholder="Введите владельца атрибутов генерации"
                    value={filters.company_name || ''}
                    onChange={(e) => handleChange('company_name', e.target.value)}
                    style={{ borderRadius: 8 }}
                />
            </div>

            <div style={{ width: 380 }}>
                <Text>Номер свидетельства</Text>
                <Input
                    placeholder="Введите номер"
                    value={filters.number || ''}
                    onChange={(e) => handleChange('number', e.target.value)}
                    style={{ borderRadius: 8 }}
                />
            </div>

            <div style={{ width: 470 }}>
                <Text>Объем атрибутов генерации</Text>
                <Space style={{ margin: 0 }} direction={'horizontal'}>
                    <InputNumber
                        placeholder="С"
                        value={filters.certificate_volume_start}
                        onChange={(value) => handleChange('certificate_volume_start', value || '')}
                        style={{ width: 230, borderRadius: 8 }}
                    />
                    <InputNumber
                        placeholder="По"
                        value={filters.certificate_volume_end}
                        onChange={(value) => handleChange('certificate_volume_end', value || '')}
                        style={{ width: 230, borderRadius: 8 }}
                    />
                </Space>
            </div>
        </Space>
    )
}

export default Filter
